<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    class="kitty-html-sanitaized"
    :class="additionalClass"
    v-html="sanitizedHtml"
  ></div>
  <!-- eslint-enable vue/no-v-html -->
</template>

<script>
import HtmlSanitizer from '../../../utils/HtmlSanitizer.js'

export default {
  props: {
    html: {
      type: String,
      required: true
    },
    additionalClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    sanitizedHtml() {
      return HtmlSanitizer.sanitize(this.html)
    }
  }
}
</script>

<style lang="scss">
// FIXME: scopedにするとスタイルがいい感じに当たらないので、渋々scopedを外してる
// v-html で生成されたDOMは、:deepセレクターを使う必要があるとのこと
@import '../../../../../stylesheets/customer/components/html_contents.scss';

.kitty-html-sanitaized {
  @extend %html_contents;
}
</style>
